var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphoneid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2913 5.00391C19.2251 5.07766 17.9788 5.7602 17.2526 6.64901C16.5901 7.45531 16.0451 8.65288 16.2576 9.81671C17.4226 9.85296 18.6263 9.15416 19.3238 8.25036C19.9763 7.40906 20.4701 6.21898 20.2913 5.00391Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5044 11.7086C23.4807 10.4247 22.0419 9.67969 20.6832 9.67969C18.8895 9.67969 18.1307 10.5385 16.8845 10.5385C15.5995 10.5385 14.6232 9.68219 13.072 9.68219C11.5483 9.68219 9.92577 10.6135 8.89703 12.2061C7.45079 14.4487 7.69828 18.6652 10.042 22.2566C10.8808 23.5417 12.0008 24.9868 13.4657 24.9993C14.7695 25.0118 15.137 24.163 16.9032 24.1543C18.6695 24.1443 19.0045 25.0106 20.3057 24.9968C21.7719 24.9856 22.9532 23.3842 23.7919 22.0991C24.3932 21.1778 24.6169 20.7141 25.0832 19.674C21.6919 18.3827 21.1482 13.5599 24.5044 11.7086Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.5C25.3365 0.5 32.5 7.66384 32.5 16.501C32.5 25.3381 25.3365 32.502 16.5 32.502C7.66347 32.502 0.5 25.3381 0.5 16.501C0.500038 7.66384 7.6635 0.5 16.5 0.5Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneid);
export default __webpack_public_path__ + "static/media/iphone id.81073cd468e9bc76d9c6583e04ebc7c0.svg";
export { ForwardRef as ReactComponent };